import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';

export const reactPlugin = new ReactPlugin();

export const AppInsights = new ApplicationInsights({
  config: {
    // Additional docs: https://github.com/microsoft/ApplicationInsights-JS#configuration

    enableAutoRouteTracking: false,
    enableAjaxErrorStatusText: true,

    connectionString: import.meta.env.MAPIQ_APP_INSIGHTS,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    disableFetchTracking: false,
    enableUnhandledPromiseRejectionTracking: true,
    extensions: [reactPlugin],
  },
});
